import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useState } from 'react'
import useSingleBroadcast from 'hooks/useSingleBroadcast'
import {
	getBroadcastEnquiriesAction,
	setBroadcastEnquiriesPage,
} from 'slices/broadcastEnquiries'
import { isEqual } from 'lodash'

const useBroadcastEnquiries = () => {
	const [fetched, setFetched] = useState(false)

	const { broadcast } = useSingleBroadcast()

	const reduxState = useAppSelector(state => state.broadcastEnquiries, isEqual)

	const dispatch = useAppDispatch()

	const { loading, page } = reduxState

	const refresh = () => {
		if (broadcast && broadcast._id) {
			setFetched(true)
			dispatch(getBroadcastEnquiriesAction(broadcast._id))
		}
	}

	const setPage = (p: number) => {
		dispatch(setBroadcastEnquiriesPage(p))
	}

	useEffect(() => {
		if (!loading) {
			refresh()
		}
	}, [fetched, broadcast?._id, page])

	return { ...reduxState, refresh, setPage }
}

export default useBroadcastEnquiries
